import { Three2DLayers } from "redhotmagma-visualization/Three/Three2DLayers";

export class CustomThree2DLayers extends Three2DLayers {
  setupDefaultControls(...params) {
    super.setupDefaultControls(...params);
    super.toggleCameraLock(true);
  }
}
